<div class="detail">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <div class="title">跳转提醒</div>
  <div class="txt">
    即将前往<ng-container *ngIf="data === 'popcorn'"
      >爆米花 <span>https://www.popcorn.plus</span>
    </ng-container>
    <ng-container *ngIf="data === 'jiegehao'"
      >借个号 <span>https://jiegehao.cn</span>
    </ng-container>
  </div>
  <div class="btn" (click)="onOk()">确认</div>
</div>
